import React from "react";
import { useContainerBulkUploadStore } from "./useContainerBulkUploadStore";

const ContainerBulkUpload = () => {
  const { bulkUploadData } = useContainerBulkUploadStore();



  return (
    <div>

    </div>
  );
};

export default ContainerBulkUpload;
